import { useCallback, useEffect, useState } from 'react';
import { Avatar, Box, HStack, Text } from '@chakra-ui/react';
import { Tooltip } from '@components/ui/tooltip';
import { toast } from 'react-toastify';
import type { UserProfileType } from '@customTypes/user';
import api from '@services/api';

const UserProfile = () => {
  const [profile, setProfile] = useState<UserProfileType | null>(null);

  const getProfile = useCallback(async () => {
    try {
      const response = await api.get('/profile/me');
      setProfile(response.data);
    } catch {
      toast.error('Erro ao carregar o perfil.');
    }
  }, []);

  useEffect(() => {
    getProfile();
  }, [getProfile]);

  if (!profile) return null;

  const emailCut = profile.email.length > 20
    ? `${profile.email.slice(0, 20)}...`
    : profile.email;

  return (
    <HStack gap="3" justify="space-between">
      <HStack gap="3">
        <Avatar.Root>
          <Avatar.Fallback />
          {profile.thumbnail_url && (
            <Avatar.Image src={profile.thumbnail_url} />
          )}
        </Avatar.Root>
        <Box>
          <Text textStyle="sm" fontWeight="medium">
            {profile.name}
          </Text>
          <Tooltip
            content={profile.email}
            showArrow
          >
            <Text textStyle="sm" color="fg.muted">
              {emailCut}
            </Text>
          </Tooltip>
        </Box>
      </HStack>
    </HStack>
  );
};

export default UserProfile;
